import React from "react";
import BoostContainer from "pages/Boost/components/BoostContainer";
import { BoostLandingAutoLoan } from "./BoostLandingAutoLoan";

const TomoBoostAutoLoan = () => {
  return (
    <BoostContainer relative>
      <div className="pt-16 lg:pt-24 pb-24">
        <BoostLandingAutoLoan />
      </div>
    </BoostContainer>
  );
};

export default TomoBoostAutoLoan;
